import {Component, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {Layout} from '../../../model/catalogo';
import {ModalService} from '../../../service/modal.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {ConstantesApiService} from '../../../service/api/constantes.api';
import {TipoEstado} from '../../../model/constantes';
import {Router} from '@angular/router';
import {CatalogoApiService} from './../../../service/api/catalogo.api';
import {GlobalService} from './../../../service/global.service';
import {DetalhamentoApiService} from './../../../service/api/detalhamento.api';
import {IMyDpOptions} from 'mydatepicker';
import {
    FiltroLayout,
    FiltroAlteracaoEstado,
    FiltrosDeLayout,
    ResultadoFiltroDetalhaLayout,
    FiltroMetadata,
    ResultadoFiltroLayout
} from './../../../model/filtros';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Component({
    selector: 'layout-arquivo',
    templateUrl: './layout-arquivo.component.html',
    styleUrls: ['./layout-arquivo.component.css', '../artefato.css']
})
export class ArtefatoLayoutArquivoComponent {

    layoutsArquivo: Array<Layout> = new Array<Layout>();
    todosLayoutsArquivo: Array<Layout> = new Array<Layout>();
    resultados: ResultadoFiltroLayout = new ResultadoFiltroLayout();
    estados: Array<TipoEstado> = new Array<TipoEstado>();

    //filtros
    codigo = new FormControl('', []);
    estado = new FormControl('0', []);
    alteracaoEstado = new FormControl('', []);
    versao = new FormControl('', []);
    descricao = new FormControl('', []);
    matricula = new FormControl('', []);
    nome = new FormControl('', []);
    dtInicio = new FormControl('', []);
    dtFim = new FormControl('', []);

    //paginacao
    pagina: number = 1;
    irpagina = new FormControl('', []);
    registrosPorPagina = new FormControl('10', []);
    isResultados: boolean = false;
    tipoOrdenacao = 'desc';

    filtroNome: String = '';
    hoje: Date = new Date();


    //resultado filtro
    detalhesLayout: ResultadoFiltroDetalhaLayout = new ResultadoFiltroDetalhaLayout();

    constructor(
        private modalService: ModalService,
        private router: Router,
        private constantesService: ConstantesApiService,
        public pesquisaService: PesquisasFiltroApiService,
        public catalogoService: CatalogoApiService,
        public globalService: GlobalService,
        public detalhamentoApiService: DetalhamentoApiService
    ) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                this.filtrarLayouts();
            }
        }
    }

    ngOnInit() {
        this.constantesService.buscaTipoEstado(0)
            .subscribe(estados => this.estados = estados as Array<TipoEstado>);
        this.filtrarLayouts();
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina++;
        this.filtrarLayouts();
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return;
        }
        this.pagina--;
        this.filtrarLayouts();
    }

    IrparaPargina() {
        if (this.irpagina.value == '') {
            this.pagina = 1;
        } else {
            this.pagina = this.irpagina.value;
        }

        if (this.resultados.metadata.paginaTotal >= this.irpagina.value) {
            this.filtrarLayouts();
        } else {
            this.irpagina.setValue(1);
            this.modalService.exibirMensagem('Erro', 'Página inexistente.', 'Fechar');
        }
    }

    alterarRegistrosPorPagina() {
        if (this.registrosPorPagina.value != null && this.registrosPorPagina.value != '') {
            if (this.resultados.metadata.paginaTotal >= this.irpagina.value) {
                this.filtrarLayouts();
            } else {
                this.irpagina.setValue(1);
                this.modalService.exibirMensagem('Erro', 'Página inexistente.', 'Fechar');
            }
        }
    }


    public myDatePickerOptions: IMyDpOptions = {
        // dateFormat: 'dd/mm/yyyy',
        dateFormat: 'yyyy-mm-dd',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: true,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    detalharLayout(codLayout, versao) {
        this.detalhamentoApiService.detalhaLayout(codLayout, versao)
            .subscribe(response => {
                    this.detalhesLayout = response;
                    $('#detalheModal').modal('show');
                },
                erro => {
                });
    }

    /*
    
        editarLayout(codLayout: number, versao: number) {
            this.router.navigate(['/cadastro-layout', codLayout, versao]);
        }
    */

    /*  excluirLayout(codLayout: number, versao: number) {
          this.modalService.abrirPaginaModal("exclusao-layout-modal", {}, { "codigo": codLayout, "versao": versao }, "Excluir Layout", "Fechar")
          .subscribe(layout => {
              this.filtrarLayouts();
          });
      }
  */
    novoLayout() {
        this.router.navigate(['/artefato-cadastro-layout-arquivo']);
    }


    editarLayout(codigo: number, versao: number) {
        this.router.navigate(['/artefato-cadastro-layout-arquivo', codigo, versao]);
    }


    filtrarLayouts() {
        let filtros: Array<any> = new Array<any>();
        this.pesquisaService.filtraOperacao(filtros);

        this.globalService.loading = true;
        this.pesquisaService.mudarPagina(this.pagina);
        // this.pesquisaService.filtraLayout(this.getFiltros())
        this.pesquisaService.filtraLayoutPaginado(this.getFiltros())
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    this.resultados = listaItens as ResultadoFiltroLayout;
                    this.isResultados = true;
                },
                erro => {
                    this.globalService.loading = false;
                    this.isResultados = false;
                    if (erro.status == 404) {
                        this.resultados.layouts = new Array<Layout>();
                    }
                    this.globalService.loading = false;
                }
            );

    }

    getFiltros() {

        let filtros = new FiltrosDeLayout();
        let filtroLayout = new FiltroLayout();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = this.registrosPorPagina.value;
        filtroMetadata.ordenacao = this.tipoOrdenacao;

        // filtro layout
        if (this.codigo.value != '') {
            filtroLayout.codigo = this.codigo.value;

        }
        if (this.versao.value != '') {
            filtroLayout.versao = this.versao.value;
        }
        if (this.nome.value != '') {
            filtroLayout.nome = this.nome.value;
        }
        if (this.estado.value != '' && this.estado.value != '0') {
            filtroLayout.codTipoEstado = this.estado.value;
        }
        if (this.descricao.value != '') {
            filtroLayout.descricao = this.descricao.value;
        }

        // filtro alteracao estado
        if (this.alteracaoEstado.value != '' && this.alteracaoEstado.value != '0') {
            filtroAlteracaoEstado.codTipoEstado = this.alteracaoEstado.value;
        }
        if (this.matricula.value != '') {
            filtroAlteracaoEstado.matricula = this.matricula.value;
        }
        if (this.dtInicio.value != '') {
            filtroAlteracaoEstado.dataInicial = this.dtInicio.value.formatted;
        }
        if (this.dtFim.value != '') {
            filtroAlteracaoEstado.dataFinal = this.dtFim.value.formatted;
        }

        filtros.filtroLayout = filtroLayout;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }


    alterarEstado(codigo, versao, tipoOperacao) {

        let msgSucesso = '';
        let msgErro = '';
        let msgAtualizacao = '';

        switch (tipoOperacao) {
            case 'despacha':
                msgSucesso = 'Layout despachado com sucesso.';
                msgErro = 'Ocorreu um erro ao despachar o Layout.';
                msgAtualizacao = 'Item despachado pelo sistema Administração Web.';
                break;
            case 'aprova':
                msgSucesso = 'Layout aprovado com sucesso.';
                msgErro = 'Ocorreu um erro ao aprovar o Layout.';
                msgAtualizacao = 'Item aprovado pelo sistema Administração Web.';
                break;
            case 'ativa':
                msgSucesso = 'Layout ativado com sucesso.';
                msgErro = 'Ocorreu um erro ao ativar o Layout.';
                msgAtualizacao = 'Item ativado pelo sistema Administração Web.';
                break;
            case 'inativa':
                msgSucesso = 'Layout inativado com sucesso.';
                msgErro = 'Ocorreu um erro ao inativar o Layout.';
                msgAtualizacao = 'Item inativado pelo sistema Administração Web.';
                break;
        }

        this.globalService.loading = true;
        this.catalogoService.operacaoLayout(codigo, versao, tipoOperacao, msgAtualizacao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.filtrarLayouts();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    }
                }
            );

    }


    detalhesLayoutAntigo(codLayout: number, versao: number) {
        this.modalService.abrirPaginaModal('detalhe-layout-arquivo-modal', {}, {
            'codigo': codLayout,
            'versao': versao
        }, 'Detalhes Layout de Arquivo', 'Fechar');
    }


    novoLayoutArquivo() {
        this.router.navigate(['/artefato-cadastro-layout-arquivo']);
    }

    /*
        getTodosLayouts() {
    
            let filtros: Array<any> = new Array<any>();
            this.pesquisaService.filtraLayout(filtros)
            .subscribe(
                listaItens => {
                    this.layoutsArquivo = listaItens as Array<Layout>;
                    this.todosLayoutsArquivo = listaItens as Array<Layout>;
                },
                erro => {
                    if (erro.status == 404) {
                        this.layoutsArquivo = new Array<Layout>();
                        this.todosLayoutsArquivo = new Array<Layout>();
                    }
                }
            );
    
        }
       */

    getEstado(codigo: Number) {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
        }
        return '-';
    }

    getAcao(codigo: Number) {
        return 'Próxima Ação';
    }

    buscaNome() {
        this.filtroNome = this.nome.value;
    }


    excluirLayout(codLayout: number, versao: number) {
        let msgSucesso = 'Layout removido com sucesso.';
        let msgErro = 'Ocorreu um erro ao remover o Layout.';
        this.catalogoService.removeLayout(codLayout, versao).subscribe(
            response => {
                this.globalService.loading = false;
                this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                this.filtrarLayouts();

            },
            erro => {
                this.globalService.loading = false;
                if (erro.status == 404 || erro.status == 500) {
                    this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                }
                if (erro.status == 403) {
                    this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                }
            }
        );
    }

    /*
        buscaEstado() {
            if (this.estado.value > 0) {
                this.layoutsArquivo = new Array<Layout>();
                this.todosLayoutsArquivo.forEach(layout => {
                    if (layout.codTipoEstado == this.estado.value) {
                        this.layoutsArquivo.push(layout);
                    }
                });
            } else if (this.estado.value == 0) {
                this.layoutsArquivo = this.todosLayoutsArquivo;
            }
        }
    
    */

    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }
}



// WEBPACK FOOTER //
// ./src/app/artefato/layout-arquivo/layout-arquivo.component.ts